<!-- @format -->

<template>
    <div v-if="!progress" :class="props.class">
        <div class="bg-color w-100 h-30" style="min-height: 50px;">&nbsp;</div>
        <div class="d-flex align-center gap-4 my-2">
            <div class="bg-color rounded w-30 h-70" style="min-height: 200px;">&nbsp;</div>
            <div class="bg-color rounded w-70 h-60" style="min-height: 200px;">&nbsp;</div>
        </div>
        <div class="bg-color w-100 h-10" style="min-height: 40px;">&nbsp;</div>
    </div>
    <div v-else :class="props.class">
        <v-progress-linear indeterminate color="grey" rounded height="50px" class="w-100 mb-2"></v-progress-linear>
        <div class="d-flex align-center gap-4 mx-4">
            <div class="mb-2 mr-auto w-30">
                <v-progress-linear indeterminate color="grey" height="200px"></v-progress-linear>
            </div>
            <div class="w-70 mb-2">
                <v-progress-linear indeterminate color="grey" height="200px"></v-progress-linear>
            </div>
        </div>
        <v-progress-linear indeterminate color="grey" rounded height="40px" class="w-100 mb-2"></v-progress-linear>
    </div>
</template>
<script setup>
const props = defineProps({
    class: {
        type: String,
        default: ""
    },
    progress: {
        type: Boolean,
        default: false
    }
})
</script>
